import React, { useState } from 'react';
import { FlexibleBenefitsList } from '../components/FlexibleBenefitsList';
import { FBPAllocationDeclarationModal } from '../components/AllocateDeclareFBPModal';

import { useSelector } from 'react-redux';
import { useSearchParams } from 'hooks/useSearchParams';
import loggedInUserSelectors from 'reducers/loggedInUser/selectors';

import userRoles from 'constants/userRoles';
import { usePayDetails } from '../context/PayDetailsContext';

export const FlexibleBenefitsView = () => {
  const [showAllocateModal, setShowAllocateModal] = useState<boolean>(false);

  const { urlParams } = useSearchParams();
  const loggedInUserId = useSelector(loggedInUserSelectors.peopleId);
  const loggedInUserRole = useSelector(loggedInUserSelectors.role);

  const { userData: { name: userName } } = usePayDetails();


  const isAdmin = loggedInUserRole === userRoles.ADMIN;

  const userId = urlParams.get('userId') || loggedInUserId;

  const openAllocateFlexibleBenefitsModal = () => {
    setShowAllocateModal(true);
  };

  return (
    <>
      <FlexibleBenefitsList
        openAllocateFlexibleBenefitsModal={openAllocateFlexibleBenefitsModal}
        userId={userId}
        isAdmin={isAdmin}
        userName={userName}
      />
      {showAllocateModal && (
        <FBPAllocationDeclarationModal
          isOpen={showAllocateModal}
          onClose={() => setShowAllocateModal(false)}
          userId={userId}
          isAdmin={isAdmin}
          userName={userName ?? ''}
        />
      )}
    </>
  );
};
